// DashboardEditor.jsx 
import React, { useEffect, useRef, useState } from 'react';
import { useDashboardCESDK } from '../hooks/useDashboardCESDK';

const DashboardEditor = ({ onEditorReady }) => {
  const containerRef = useRef(null);
  const [initAttempted, setInitAttempted] = useState(false);
  const { 
    cesdk, 
    status, 
    error: cesdkError, 
    isReady, 
    initialize 
  } = useDashboardCESDK();

  // Add check for checkout pages
  const isCheckoutPage = window.location.pathname.includes('/checkout') || 
                         window.location.pathname.includes('/stripe-checkout');

  useEffect(() => {
    // Skip initialization completely if on checkout page
    if (isCheckoutPage) {
      console.log("DashboardEditor: Detected checkout page - skipping CESDK initialization");
      // Still notify parent that initialization is "complete" (skipped)
      if (onEditorReady && typeof onEditorReady === 'function') {
        onEditorReady(null);
      }
      return;
    }

    // Skip if initialization already occurred or already attempted
    if (!containerRef.current || cesdk || initAttempted) {
      return;
    }
    
    const initEditor = async () => {
      try {
        console.log("🚀 Initializing CESDK for new dashboard...");
        setInitAttempted(true);
        
        // Initialize with our new hook
        const instance = await initialize(containerRef.current, {
          theme: "light",
          ui: {
            elements: {
              navigation: { enabled: false },
              panels: { enabled: false },
              dock: { enabled: false },
              toolbar: { enabled: false }
            }
          }
        });
        
        if (instance && onEditorReady && typeof onEditorReady === 'function') {
          onEditorReady(instance);
          console.log("✅ CESDK initialized successfully for new dashboard");
        } else if (!instance) {
          console.warn("⚠️ CESDK initialization returned null - proceeding without editor");
          // Still call onEditorReady with null to signal that initialization is complete
          if (onEditorReady && typeof onEditorReady === 'function') {
            onEditorReady(null);
          }
        }
      } catch (err) {
        console.error("❌ CESDK initialization failed for new dashboard:", err);
        // Still call onEditorReady with null to allow the application to continue
        if (onEditorReady && typeof onEditorReady === 'function') {
          onEditorReady(null);
        }
      }
    };
    
    initEditor();
  }, [initialize, cesdk, onEditorReady, initAttempted, isCheckoutPage]);

  // Don't render anything on checkout pages
  if (isCheckoutPage) {
    return null;
  }

  // Clean, minimal UI with no visible error messages to users
  return (
    <div>
      <div 
        ref={containerRef}
        style={{ 
          width: '800px', 
          height: '600px',
          position: 'absolute',
          left: '-9999px'
        }}
      ></div>
    </div>
  );
};

export default DashboardEditor; 